import { useState, useEffect } from 'react';

//icons
import CloseIcon from '@mui/icons-material/Close';

export function EmergencyAddForm({ isOpen,
  onClose,
  employeeId,
  addEmployeesEmergency
}) {
  const [name, setName] = useState('');
  const [relationship, setRelationship] = useState('');
  const [contactNumber, setContactNumber] = useState('');
  const [address, setAddress] = useState('');

  const handleSubmit = () => {
    if (!name
      || !relationship
      || !contactNumber
      || !address
    ) {
      alert("Required to fill up all data");
      return; // Exit early if fields are empty
    }

    addEmployeesEmergency(employeeId, name, relationship, contactNumber, address);
    // Clear form fields
    setName('');
    setRelationship('');
    setContactNumber('');
    setAddress('');
  };

  const handleClose = () => {
    onClose();
    setName('');
    setRelationship('');
    setContactNumber('');
    setAddress('');
  }

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div id="emergency-form" className="add-employees-form">
              <div className="popUp-header row">
                <div className='popUp-title'><h3 style={{ color: "#668fca" }}>Add Emergency Contact</h3></div>
                <div className='popUp-close'><CloseIcon onClick={() => handleClose()} /></div>
              </div>
              <div className="popUp-body">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Name</div>
                  <div className="info-item-input"><input id="AddEmployee-Emergency-Name" placeholder="Name" onChange={(e) => setName(e.target.value)} /></div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Relationship</div>
                  <div className="info-item-input"><input id="AddEmployee-Emergency-Relationship" placeholder="Relationship" onChange={(e) => setRelationship(e.target.value)} /></div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Address</div>
                  <div className="info-item-input"><input id="AddEmployee-Emergency-Address" placeholder="Middle Address" onChange={(e) => setAddress(e.target.value)} /></div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Contact Number</div>
                  <div className="info-item-input"><input id="AddEmployee-Emergency-ContactNumber" placeholder="Contact Number" onChange={(e) => setContactNumber(e.target.value)} /></div>
                </div>
                <div className="emergency-tab-footer tab-footer">
                  <div className="buttons row" style={{ justifyContent: "end" }}>
                    <button id="add-emergency"
                      className="save row"
                      onClick={handleSubmit}>
                      SAVE
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  )
}
export function EmergencyEditForm({ isOpen,
  onClose,
  editData,
  employeeId,
  addEmployeesEmergency
}) {
  const [name, setName] = useState('');
  const [relationship, setRelationship] = useState('');
  const [contactNumber, setContactNumber] = useState('');
  const [address, setAddress] = useState('');

  const handleSubmit = () => {
    if (!name
      || !relationship
      || !contactNumber
      || !address
    ) {
      alert("Required to fill up all data");
      return; // Exit early if fields are empty
    }

    addEmployeesEmergency(employeeId, name, relationship, contactNumber, address);
    // Clear form fields
    setName('');
    setRelationship('');
    setContactNumber('');
    setAddress('');
  };

  const handleClose = () => {
    onClose();
    setName('');
    setRelationship('');
    setContactNumber('');
    setAddress('');
  }

  useEffect(() => {
    if (isOpen) {
      setName(editData.name);
      setRelationship(editData.relationship);
      setContactNumber(editData.contactNumber);
      setAddress(editData.address);
    }
  }, [isOpen, editData]);

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div id="emergency-form" className="add-employees-form">
              <div className="popUp-header row">
                <div className='popUp-title'><h3 style={{ color: "#668fca" }}>Edit Emergency Contact</h3></div>
                <div className='popUp-close'><CloseIcon onClick={() => handleClose()} /></div>
              </div>
              <div className="popUp-body">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Name</div>
                  <div className="info-item-input"><input value={name} id="AddEmployee-Emergency-Name" placeholder="Name" onChange={(e) => setName(e.target.value)} /></div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Relationship</div>
                  <div className="info-item-input"><input value={relationship} id="AddEmployee-Emergency-Relationship" placeholder="Relationship" onChange={(e) => setRelationship(e.target.value)} /></div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Address</div>
                  <div className="info-item-input"><input value={address} id="AddEmployee-Emergency-Address" placeholder="Middle Address" onChange={(e) => setAddress(e.target.value)} /></div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Contact Number</div>
                  <div className="info-item-input"><input value={contactNumber} id="AddEmployee-Emergency-ContactNumber" placeholder="Contact Number" onChange={(e) => setContactNumber(e.target.value)} /></div>
                </div>
                <div className="emergency-tab-footer tab-footer">
                  <div className="buttons row" style={{ justifyContent: "end" }}>
                    <button id="add-emergency"
                      className="save row"
                      onClick={handleSubmit}>
                      SAVE
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  )
}